<template>
  <div class="selectDatas">
    <div class="el-select__tags" v-for="tag in selectDatas" :key="tag.index">
      <el-tooltip :content="tag.name" placement="top">
        <el-tag size="mini" closable @close="handleClose(tag)"><span class="tagcontent">{{ tag.name }}</span></el-tag>
      </el-tooltip>
    </div>
    <el-input size="small"></el-input>
    <el-button icon="el-icon-plus" circle class="new-tag" size="mini" @click="handleSelect" />
    <DataDic :visible.sync="dialogVisible" :selectDatas="selectDatas" @onChecked="handleChecked"></DataDic>
  </div>
</template>
<script>
import DataDic from './dataDic.vue'
import _ from 'lodash'
export default {
  components: { DataDic },
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectDatas: [],
      dialogVisible: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.selectDatas = this.datas
    }, 100)
  },
  methods: {
    handleSelect() {
      this.dialogVisible = !this.dialogVisible
    },
    handleClose(tag) {
      console.log(this.selectDatas)
      const tags = _.filter(this.selectDatas, (data) => {
        return data.id !== tag.id
      })
      this.selectDatas = tags
      this.$emit('onChecked', tags)
    },
    handleChecked(data) {
      this.$emit('onChecked', data)
    }
  },
  watch: {
    datas(data) {
      this.selectDatas = data
    }
  }
}
</script>
<style lang="scss" scoped>
.selectDatas {
  :deep(.el-select__tags) {
    padding: 0 15px;
  }
  :deep(.el-tag .el-icon-close) {
    top: -6px;
  }
  .tagcontent {
    width: auto;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100px;
  }
  .new-tag {
    position: absolute;
    right: 10px;
    top: 3px;
    z-index: 2;
  }
}
</style>
